import { render } from "./Champ_Select_Inscription_FFR.vue?vue&type=template&id=82b4e8b4"
import script from "./Champ_Select_Inscription_FFR.vue?vue&type=script&lang=js"
export * from "./Champ_Select_Inscription_FFR.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__